export const CardData = [
    {
        title:'Today Booking',
        value:'1,587',
        text:'From previous period',
        per:'+11%',
        bg_color:'bg-primary'
    },
    {
        title:'Total Amount',
        value:'$2,258',
        text:'New income',
        per:'+05%',
        bg_color:'bg-info'
    },
    {
        title:'Total Customer',
        value:'2.3k',
        text:'From previous period',
        per:'+11%',
        bg_color:'bg-warning'
    },
    {
        title:'Total Revenue',
        value:'11,5587',
        text:'From previous period',
        per:'+21%',
        bg_color:'bg-success'
    },
]